// dev-api/v1/signature/get-organizations

import fetchData from "@/api-client/fetcher";
import { useQuery } from "@tanstack/react-query";

const GET_ORGANIZATION_API = `${import.meta.env.VITE_SIGNATURE_API_URL}/signature/get-organizations`;

export const useGetSignatureOrgs = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['get-signature-orgs'],
        queryFn: () => fetchData(GET_ORGANIZATION_API, {}, true),
    })
    return { data, isLoading };
}   